import React, { useState, useEffect } from "react";
import { Form, FormGroup, Label, Input, Button, Alert } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { sendNotification, getUserData } from "../../Services/oneSignalService";

function NotificationForm() {
  const { t } = useTranslation(); // Hook for translations
  const [scheduleNotification, setScheduleNotification] = useState(false);
  const [sendType, setSendType] = useState("all");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [formValues, setFormValues] = useState({
    title: "",
    message: "",
    scheduleDateTime: "",
    segment: "",
    singleUser: "",
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const fetchedUsers = await getUserData();
      setUsers(fetchedUsers.players);
    } catch (error) {
      console.error(t("errorFetchingUsers"), error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { title, message, scheduleDateTime, segment, singleUser } = formValues;
    let recipients = [];
    let sendTime;

    if (scheduleNotification && !scheduleDateTime) {
      setErrorMessage(t("scheduleDateRequired"));
      return;
    }

    if (scheduleNotification) {
      sendTime = new Date(scheduleDateTime).getTime() / 1000;
    }

    switch (sendType) {
      case "all":
        recipients = ["All"];
        break;
      case "segment":
        recipients = [segment];
        break;
      case "multiple":
        recipients = selectedUsers.map((user) => user.value);
        break;
      case "single":
        recipients = [singleUser];
        break;
      default:
        recipients = ["All"];
    }

    try {
      await sendNotification(message, title, recipients, sendTime);
      setSuccessMessage(t("notificationSent"));
      setErrorMessage("");
      setFormValues({
        title: "",
        message: "",
        scheduleDateTime: "",
        segment: "",
        singleUser: "",
      });
      setSelectedUsers([]);
      setSendType("all");
      setScheduleNotification(false);

      setTimeout(() => setSuccessMessage(""), 5000);
    } catch (error) {
      console.error(t("errorSendingNotification"), error);
      setErrorMessage(t("failedToSendNotification"));
      setTimeout(() => setErrorMessage(""), 5000);
    }
  };

  return (
    <>
      {successMessage && <Alert color="success">{successMessage}</Alert>}
      {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="title">{t("notificationTitle")}</Label>
          <Input
            id="title"
            name="title"
            placeholder={t("enterNotificationTitle")}
            value={formValues.title}
            onChange={handleInputChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="message">{t("notificationMessage")}</Label>
          <Input
            type="textarea"
            id="message"
            name="message"
            placeholder={t("enterNotificationMessage")}
            value={formValues.message}
            onChange={handleInputChange}
            required
          />
        </FormGroup>
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              checked={scheduleNotification}
              onChange={() => setScheduleNotification(!scheduleNotification)}
            />{" "}
            {t("scheduleNotification")}
          </Label>
        </FormGroup>
        {scheduleNotification && (
          <FormGroup>
            <Label for="scheduleDateTime">{t("scheduleDateTime")}</Label>
            <Input
              type="datetime-local"
              name="scheduleDateTime"
              id="scheduleDateTime"
              value={formValues.scheduleDateTime}
              onChange={handleInputChange}
              required={scheduleNotification}
            />
          </FormGroup>
        )}
        {/* <FormGroup>
          <Label for="sendType">{t("sendTo")}</Label>
          <Input
            type="select"
            name="sendType"
            id="sendType"
            value={sendType}
            onChange={(e) => setSendType(e.target.value)}
          >
            <option value="all">{t("allUsers")}</option>
            <option value="segment">{t("segment")}</option>
            <option value="multiple">{t("multipleUsers")}</option>
            <option value="single">{t("singleUser")}</option>
          </Input>
        </FormGroup> */}
        {/* Similar updates for other form fields */}
        <Button color="primary" type="submit">
          {t("sendNotification")}
        </Button>
      </Form>
    </>
  );
}

export default NotificationForm;
